var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{class:[_vm.$slots.titleactions ? 'fbt-slider-title' : '', 'form-box-title']},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._t("titleappend"),_vm._t("titleactions")],2),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }